import React, { ComponentProps } from 'react';
import { PageMembershipMatchingRuleReportsDefaultView } from './views/PageMembershipMatchingRuleReportsDefaultView';
import { DefaultView, Views } from '../../types/BlockWithViews';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';

type PageMembershipMatchingRuleReportsBlockProps = Views<DefaultView<PageMembershipMatchingRuleReportsDefaultView>>;

function PageMembershipMatchingRuleReports(props: PageMembershipMatchingRuleReportsBlockProps) {
  return <PageMembershipMatchingRuleReportsDefaultView {...props.views.default} />;
}

export const PageMembershipMatchingRuleReportsBlock = asFetchableBlock(
  PageMembershipMatchingRuleReports,
  BlockType.pagemembershipmatchingrulereports
);
export type PageMembershipMatchingRuleReportsBlock = ComponentProps<typeof PageMembershipMatchingRuleReportsBlock>;
